import './en';
import './sv';



// WEBPACK FOOTER //
// ./.tmp/bs-moment/locale/index.ts